import { useState } from 'react'
import { Stack, TextField } from '@fluentui/react'
import { Send28Filled } from '@fluentui/react-icons'

import styles from './question-input.module.css'
import {useMediaQuery, useTheme} from "@mui/material";

export const QuestionInput = ({
  onSend,
  disabled,
  placeholder,
  clearOnSend,
}) => {
  const [question, setQuestion] = useState('')
  const theme = useTheme();
  const lessThanSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const sendQuestion = () => {
    if (disabled || !question.trim()) {
      return
    }

    onSend(question)

    if (clearOnSend) {
      setQuestion('')
    }
  }

  const onEnterPress = (ev) => {
    if (ev.key === 'Enter' && !ev.shiftKey) {
      ev.preventDefault()
      sendQuestion()
    }
  }

  const onQuestionChange = (ev, newValue) => {
    /*if (!newValue) {
            setQuestion("");
        } else if (newValue.length <= 1000) {
            setQuestion(newValue);
        }*/

    setQuestion(newValue)
  }

  const sendQuestionDisabled = disabled || !question.trim()

  return (
      <div className={styles.questionContainer}>
        <Stack horizontal className={styles.questionInputContainer}>
          <TextField
              className={styles.questionInputTextArea}
              placeholder={ lessThanSmall ? (placeholder.slice(0, 15) + '...') : placeholder}
              multiline
              autoAdjustHeight
              rows={1}
              borderless
              value={question || ''}
              onChange={onQuestionChange}
              onKeyDown={onEnterPress}
              styles={{ overflow: 'hidden' }}
          />
        </Stack>
        <div className={styles.questionInputButtonsContainer}>
          <div
              className={`${styles.questionInputSendButton} ${
                  sendQuestionDisabled ? styles.questionInputSendButtonDisabled : ''
              }`}
              aria-label="Ask question button"
              onClick={sendQuestion}
          >
            <Send28Filled primaryFill="rgba(115, 118, 225, 1)" />
          </div>
        </div>
      </div>
  )
}
